<template>
  <div data-v-f531b812="" class="app app-ti_green">
    <div data-v-8a75a126="" data-v-f531b812="" class="header">
      <div data-v-8a75a126="" class="header__top-wrapper">
        <div data-v-8a75a126="" class="van-nav-bar van-nav-bar--fixed fixed-top nav-header">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="$router.back()">
              <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
            </div>
            <div class="van-nav-bar__title van-ellipsis">{{ $t('agent_settings') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="agent-settings">
      <!-- 代理设置表单 -->
      <div class="settings-form">
        <van-form @submit="submitForm">
          <van-field :label="$t('agent_link_prefix')" v-model="settings.agent_uri_pre" :placeholder="$t('enter_agent_link_prefix')" />
          <van-field :label="$t('pc_agent_link')" v-model="settings.agent_pc_uri" :placeholder="$t('enter_pc_agent_link')" />
          <van-field :label="$t('wap_agent_link')" v-model="settings.agent_wap_uri" :placeholder="$t('enter_wap_agent_link')" />
          <div class="form-tips">
            <p>{{ $t('tips') }}：</p>
            <p>1. {{ $t('tip1') }}</p>
            <p>2. {{ $t('tip2') }}</p>
          </div>
          <van-button type="primary" native-type="submit" block>{{ $t('save_settings') }}</van-button>
        </van-form>
      </div>

      <!-- 代理规则 -->
      <div class="agent-rules">
        <div class="rules-header">
          <h3>{{ $t('agent_rules') }}</h3>
        </div>
        <div class="rules-content">
          <div class="rule-item">
            <div class="rule-title">{{ $t('commission_rules') }}</div>
            <div class="rule-desc">
              <p>1. {{ $t('commission_rule1') }}</p>
              <p>2. {{ $t('commission_rule2') }}</p>
              <p>3. {{ $t('commission_rule3') }}</p>
            </div>
          </div>
          <div class="rule-item">
            <div class="rule-title">{{ $t('rebate_rules') }}</div>
            <div class="rule-desc">
              <p>1. {{ $t('rebate_rule1') }}</p>
              <p>2. {{ $t('rebate_rule2') }}</p>
              <p>3. {{ $t('rebate_rule3') }}</p>
            </div>
          </div>
          <div class="rule-item">
            <div class="rule-title">{{ $t('promotion_rules') }}</div>
            <div class="rule-desc">
              <p>1. {{ $t('promotion_rule1') }}</p>
              <p>2. {{ $t('promotion_rule2') }}</p>
              <p>3. {{ $t('promotion_rule3') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'agentSettings',
  data() {
    return {
      settings: {
        agent_uri_pre: '',
        agent_pc_uri: '',
        agent_wap_uri: ''
      }
    };
  },
  created() {
    this.getAgentSettings();
  },
  methods: {
    getAgentSettings() {
      let that = this;
      const getFromInviteList = () => {
        that.$apiFun.get('/api/team/invite/list').then(res => {
          console.log('从 /api/team/invite/list 获取代理设置:', res);
          if (res.code === 200) {
            that.settings = res.data;
          } else {
            console.error('获取代理设置失败:', res);
            that.settings = {
              agent_uri_pre: '',
              agent_pc_uri: '',
              agent_wap_uri: ''
            };
          }
        }).catch(err => {
          console.error('获取代理设置错误:', err);
          that.settings = {
            agent_uri_pre: '',
            agent_pc_uri: '',
            agent_wap_uri: ''
          };
        });
      };

      getFromInviteList();
    },
    submitForm() {
      let that = this;
      that.$apiFun.post('/api/team/invite/update', that.settings).then(res => {
        console.log('保存代理设置:', res);
        if (res.code === 200) {
          if (that.$parent && that.$parent.showTost) {
            that.$parent.showTost(1, that.$t('save_success'));
          } else {
            alert(that.$t('save_success'));
          }
        } else {
          if (that.$parent && that.$parent.showTost) {
            that.$parent.showTost(0, res.message || that.$t('save_failed'));
          } else {
            alert(res.message || that.$t('save_failed'));
          }
        }
      }).catch(err => {
        console.error('保存代理设置错误:', err);
        if (that.$parent && that.$parent.showTost) {
          that.$parent.showTost(0, that.$t('save_failed_retry'));
        } else {
          alert(that.$t('save_failed_retry'));
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.agent-settings {
  margin-top: 60px;
  padding: 15px;
  
  .settings-form {
    background: #fff;
    border-radius: 10px;
    padding: 15px;
    margin-bottom: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    
    .form-tips {
      margin: 15px 0;
      padding: 10px;
      background: #f5f5f5;
      border-radius: 5px;
      
      p {
        margin: 5px 0;
        font-size: 12px;
        color: #666;
        
        &:first-child {
          font-weight: bold;
          color: #333;
        }
      }
    }
    
    .van-button {
      margin-top: 10px;
      background: #084ccb;
      color: #fff;
    }
  }
  
  .agent-rules {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    
    .rules-header {
      padding: 15px;
      border-bottom: 1px solid #f0f0f0;
      
      h3 {
        margin: 0;
        font-size: 16px;
        color: #333;
      }
    }
    
    .rules-content {
      padding: 15px;
      
      .rule-item {
        margin-bottom: 15px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .rule-title {
          font-size: 14px;
          font-weight: bold;
          color: #333;
          margin-bottom: 10px;
        }
        
        .rule-desc {
          p {
            margin: 5px 0;
            font-size: 12px;
            color: #666;
            line-height: 1.4;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/agentSettings.vue